import { useCommonTranslation } from '../i18n/useCommonTranslation';
import { NHSValidate } from '../../utils/nhsValidator';
import { useMemo } from 'react';
import {
  hookFromTrimBeforeValidation,
  UK_POST_CODE_REGEX,
} from '../../utils/helpers';
import { SiteSettings } from '../../types/sites';
import {
  isGpSurgeryRequired,
  isNhsNumberRequired,
  isPostCodeRequired,
} from '../../utils/siteUtils';

export const useSiteValidationRules = ({
  siteSettings,
}: {
  siteSettings: SiteSettings;
}) => {
  const { t } = useCommonTranslation();

  return useMemo(() => {
    return {
      nhsNumberRules: {
        ...hookFromTrimBeforeValidation,
        required:
          isNhsNumberRequired(siteSettings) && t<string>('must-not-empty'),
        validate: (value?: string) => {
          return (
            !value || NHSValidate(value) || (t('nhs-validation') as string)
          );
        },
        setValueAs: (value: string) => {
          // remove whitespaces
          return value.replace(/\s/g, '');
        },
      },
      postcodeRules: {
        ...hookFromTrimBeforeValidation,
        required:
          isPostCodeRequired(siteSettings) && t<string>('must-not-empty'),
        pattern: {
          value: UK_POST_CODE_REGEX,
          message: t('postcode-validation') as string,
        },
      },
      gpRules: {
        ...hookFromTrimBeforeValidation,
        required:
          isGpSurgeryRequired(siteSettings) && (t('must-not-empty') as string),
      },
    };
  }, [siteSettings, t]);
};
